export default __webpack_public_path__ + "static/media/Roboto-Italic.c58a86b4.ttf";